import { Transform, TransformFnParams } from 'class-transformer';
import { PersonnelAddressModel, PersonnelMetadataModel } from '../model';
import { AddressModel, AddressType } from '@core/address';
import { parseAddressesToPersonnelAddress } from '../util';

export const PersonnelAddressDecorator = () =>
  Transform((params: TransformFnParams) => {
    const addresses: Partial<InstanceType<typeof AddressModel>>[] = params.obj['addresses'];
    const metadata: Partial<InstanceType<typeof PersonnelMetadataModel>> = params.obj['metadata'];
    const address: Partial<InstanceType<typeof PersonnelAddressModel>> = params.obj['address'];

    // Addresses have 2 address as by default: Residential Local & Mailing Address Residential Local

    // if (params.obj['confirmationStatus'] === 'processing') {
    //   // debugger;
    // }

    if (Array.isArray(addresses) && addresses.length > 0) {
      return parseAddressesToPersonnelAddress({
        mailingAddressDifferent: metadata?.addressMetadata?.maillingAddressDifferent || false,
        addresses,
      });
    }

    if (address) {
      const residential = address?.residential ? AddressModel.fromJson(address.residential) : AddressModel.createEmpty();
      const mailing = address?.differentResidential ? AddressModel.fromJson(address.mailing) : AddressModel.createEmpty();
      mailing.type = AddressType.MAILING_ADDRESS;
      const personnelAddress: PersonnelAddressModel = {
        residential,
        mailing,
        differentResidential: address.differentResidential || false,
      };
      return PersonnelAddressModel.fromJson(personnelAddress);
    }

    return PersonnelAddressModel.createEmpty();
  });
